module.exports = __webpack_public_path__ + "img/login.a9172fd8.jpg";